export const getLoginPage = () => ({
  type: 'route',
  path: 'auth',
  routes: [
    {
      type: 'application',
      name: '@crm/auth',
    },
  ],
});
